import RichText from '@atoms/RichText/RichText';
import { BG_WHITE } from '@constants';
import { imageType } from '@lib/proptypes';
import ApplicationProcessSliderItem from '@molecules/ApplicationProcessSliderItem/ApplicationProcessSliderItem';
import Carousel from '@molecules/Carousel/Carousel';
import PagepartBase from '@molecules/PagepartBase/PagepartBase';
import PropTypes from 'prop-types';

import styles from './ApplicationProcess.module.scss';

function ApplicationProcess({ title, text, list, id }) {
  if (!list?.length) return null;

  return (
    <PagepartBase backgroundColor={BG_WHITE} id={id}>
      <div className={styles.header}>
        {!!title && <h2>{title}</h2>}
        {!!text && <RichText text={text} />}
      </div>
      <Carousel
        items={list}
        SlideItem={ApplicationProcessSliderItem}
        displayScrollBar
        slidesPerView={{ 0: 1.5, 640: 3.25 }}
      />
    </PagepartBase>
  );
}

ApplicationProcess.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string,
      image: imageType,
    })
  ),
};

export default ApplicationProcess;
